import axios from 'axios'

// Prefer explicit env var. Otherwise:
// - In production, build an origin-relative HTTPS URL using Vite base (/inmobiliaria/ → /inmobiliaria/backend)
// - In development, fall back to local backend
const resolvedApiBase = (() => {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined
  if (fromEnv) return fromEnv

  if (import.meta.env.PROD) {
    const base = import.meta.env.BASE_URL || '/'
    const prodUrl = new URL('backend', new URL(base, window.location.origin))
    return prodUrl.toString()
  }

  return `${window.location.protocol}//${window.location.hostname}/backend`
})()

const api = axios.create({
  baseURL: resolvedApiBase,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true
})

api.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // AuthProvider handles expired sessions; callers still receive request errors.
    return Promise.reject(error)
  }
)

export default api
